import { Box, Heading, Text, Divider, Button } from "@chakra-ui/react"
import { ArrowBackIcon } from "@chakra-ui/icons"
import Sponsor from "../components/Sponsor"
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Programma = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const toHome = () => {
        navigate('/');
    }

    return (
        <Box height='100%' width='100%' pb={3} textColor='blue.900'>
            <Heading as='h2' size={['lg', 'lg', 'xl']} noOfLines={1} pt={2} display='flex' alignItems='center' justifyContent='center'>
                <Text textColor='white'>Programma</Text> <Text ml={2} textColor='blue.900'> | 26 AGOSTO 2022</Text>
            </Heading>
            <Heading as='h3' size={['sm', 'lg', 'md']} mt={3} display='flex' flexDir={['column', null, 'row']} alignItems='center' justifyContent='center'>
                <Text textColor='gray.400'>dal basso </Text>
                <Text ml={1} textColor='green.400'>verso l’alto..</Text>
                <Text ml={1} textColor='gray.400'>dalla copert(ur)a del fiume</Text>
                <Text ml={1} textColor='green.400'>alla scoperta di antichi versi</Text>
            </Heading>

            <Box width='1000px' mx='auto' mt={5} p={5} rounded='lg' w={['full', null, '1000px']}>
                <Box>
                    <Box textAlign='left' display='flex' alignItems={['left', 'center']} flexDir={['column', null, 'row']} mb={[2, null, 0]}>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px'>
                            ORE 17:30

                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' mx={1} textColor='white' display={['none', null, 'block']}>
                            |

                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' textColor='gray.400'>
                            VIA CALAMO (ASCENSORE)

                        </Text>
                    </Box>
                    <Text fontSize={['md', 'lg', 'xl']} >
                        <span style={{ color: 'white' }}><b>saluti istituzionali </b></span> <b>PINO CAPALBO</b> Sindaco di Acri, <b>MARIO BONACCI</b> Assessore alla Cultura, <b>LUIGI MAIORANO</b> Assessore allo Spettacolo
                    </Text>
                    <Text fontSize={['md', 'lg', 'xl']} mt={2}>
                        <span style={{ color: 'white' }}><b>introduzione</b> </span> <b>FRANCESCO VOTANO</b>
                    </Text>
                </Box>

                <Divider my={3} />

                <Box>
                    <Box textAlign='left' display='flex' alignItems={['left', 'center']} flexDir={['column', null, 'row']} mb={[2, null, 0]}>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px'>
                            ORE 18:30

                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' mx={1} textColor='white' display={['none', null, 'block']}>
                            |

                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' textColor='gray.400' mx={[0, 0, 1]}>
                            da via calamo
                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' textColor='purple.700'>
                            verso via padula
                        </Text>
                    </Box>
                    <Text fontSize={['md', 'lg', 'xl']}>
                        <span style={{ color: 'white' }}> <b>street art e poesia di strada </b></span><b>IVAN TRESOLDI</b> Artista internazionale dalla periferia sud di Milano
                    </Text>
                    <Text fontSize={['md', 'lg', 'xl']} textAlign='justify' >
                        due percorsi con ritrovo e partenza nei pressi dell’ASCENSORE:
                        <br />
                        - percorso <b>scalette/ascensore</b> verso il marciapiede di Via Padula n. 149 (parte superiore ascensore)
                        <br />
                        - percorso <b>passaggio pedonale </b>verso il marciapiede di Via Padula n. 170  (angolo Via Calamo)
                    </Text>
                </Box>

                <Divider my={3} />

                <Box>
                    <Box textAlign='left' display='flex' alignItems={['left', 'center']} flexDir={['column', null, 'row']} mb={[2, null, 0]}>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px'>
                            ORE 19:00
                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' mx={1} textColor='white' display={['none', null, 'block']}>
                            |
                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' textColor='purple.700' mx={[0, 0, 1]}>
                            VIA PADULA
                        </Text>

                    </Box>
                    <Box >
                        <Text fontSize={['md', 'lg', 'xl']} mb={2}>
                            <span style={{ color: 'white' }}> <b>letture </b></span><b>ANGLAT, RAGGIO DI SOLE, COMUNITÀ DON MILANI, AGAPE</b> presso la fontana Via Padula-Via Julia
                        </Text>

                        <Text fontSize={['md', 'lg', 'xl']} mb={2}>
                            <span style={{ color: 'white' }}> <b>concerto </b></span> <b>DANILO GUIDO</b> in collaborazione con <b>The Stones, Cantine Chimento, Panificio Cassavia, Biosila, Panificio San Luigi, Mieleria Sposato</b>
                        </Text>

                        <Text fontSize={['md', 'lg', 'xl']} mb={2}>
                            <b><span style={{ color: 'white' }}>esposizione museale</span> ACRI CITTÀ DEI MUSEI, ANTONIO SALADINO, SILVIO VIGLIATURO</b> presso la <b>Sala espositiva temporanea</b>
                        </Text>

                        <Text fontSize={['md', 'lg', 'xl']} mb={2}>
                            <span style={{ color: 'white' }}><b>mostra fotografica</b> </span><b>ACRI TRA PASSATO E PRESENTE</b> di <b>ANTONIO BIAGIO SERRA, MASSIMO MILIZIA, SALVATORE DE VINCENTI</b>
                        </Text>

                        <Text fontSize={['md', 'lg', 'xl']} mb={2}>
                            <span style={{ color: 'white' }}><b> intervento musicale ed esposizione quadri </b></span><b>HELLO MUSIC ACADEMY</b> presso i nuovi spazi della <b>Bottega dell’Arte</b>
                        </Text>
                    </Box>

                </Box>

                <Divider my={3} />

                <Box>
                    <Box textAlign='left' display='flex' alignItems={['left', 'center']} flexDir={['column', null, 'row']} mb={[2, null, 0]}>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px'>
                            ORE 21:30
                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' mx={1} textColor='white' display={['none', null, 'block']}>
                            |
                        </Text>
                        <Text fontWeight='bold' textTransform='uppercase' fontSize={['1rem', null, '1.2rem']} letterSpacing='2px' textColor='yellow.400' mx={[0, 0, 1]}>
                            PIAZZA MARCONI
                        </Text>

                    </Box>
                    <Text fontSize={['md', 'lg', 'xl']} mb={2}>
                        <b><span style={{ color: 'white' }}>racconti</span> GIUSEPPE ABBRUZZO</b>
                    </Text>
                    <Text fontSize={['md', 'lg', 'xl']} mb={2}>
                        <b><span style={{ color: 'white' }}>intermezzo musicale</span> ANGELO GACCIONE & ANTONIO SCAGLIONE</b>in collaborazione con <b>Pizzeria Valentino e Antica Tabaccheria dal 1919</b>
                    </Text>
                    <Text fontSize={['md', 'lg', 'xl']}>
                        <b><span style={{ color: 'white' }}>esposizione opere artistiche</span> LUCIA PAESE </b>e <b><span style={{ color: 'white' }}>punti informativi</span> ASSOCIAZIONI PARTECIPANTI</b>
                    </Text>
                </Box>

                <Divider my={3} />

                <Button mt={5} leftIcon={<ArrowBackIcon />} colorScheme='green' textColor='white' onClick={toHome}>
                    Indietro
                </Button>
            </Box>

            <Box display='flex' flexDir='column' alignItems='center' mx='auto' width={['100%', '500px']} >
                <Sponsor />
                <Text fontWeight='extrabold' textDecor='underline' textColor='white' my={2}>Pwd by Jacopo Berlingieri 2022 </Text>
            </Box>
        </Box>
    )
}

export default Programma